export default "__VITE_ASSET__SH14QzdC__"